<template>
  <div>
    <router-view></router-view>
    <notifications group="notification" position="bottom right"></notifications>
  </div>
</template>

<script>
  import router from './router'
  export default {
    name: "App",
    created() {
      // Guard the transitions
      let vm = this;

      router.beforeResolve((to, from, next) => {
        // No token present
        if(localStorage.getItem("achiev_token") === null && to.fullPath.indexOf('?next=') === -1){
          //next('/login?next=' + to.path);

          if (from.path.length > 1 && from.name !== "Login") {
            vm.$router.push("/login?next=" + from.path);
          } else if (to.path.length > 1 && to.name !== "Login") {
            vm.$router.push("/login?next=" + to.path);
          } else {
            vm.$router.push("/login")
          }
          // Token expired
        } else if (localStorage.getItem('expires') !== null && localStorage.getItem('expires') < Math.floor(+ new Date() / 1000) && from.name !== "Login") {
          localStorage.clear();
          this.$router.push("/login");
        } else {
          next();
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue